import { StepsActions } from "../../reducers/steps/actionsNames";

export default function (step: string) {
  return {
    type: StepsActions.PreviousStep,
    step,
  };
}
